<template>
  <vc-donut
    background="white"
    foreground="grey"
    :size="200" unit="px" :thickness="20"
    :sections="sections" :total="100"
    @section-mouseover="handleMouseOver"
    @section-mouseout="handleMouseOut"
  >
    <div class="donut-center-content" style="text-align: center;">
      <template v-if="hoveredSection">
        <div class="donut-label">{{hoveredSection.label}}</div>
        <div class="donut-value">{{hoveredSection.value.toFixed(1)}}%</div>
      </template>
      <template v-else>
        <div v-if="this.graphData[0]=='cu'" class="donut-label">{{$t("central_units")}}</div>
        <div v-if="this.graphData[0]=='lamp'" class="donut-label">{{$t("lamps")}}</div>
        <div class="donut-value">{{totalDevice}}</div>
      </template>
    </div>
  </vc-donut>
</template>

<script>
import Vue from 'vue';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
Vue.use(Donut);

  export default {
    name: 'GraficoDonutReport',
    props: {
      graphData: Array
    },
    mounted(){
        this.totalDevice=this.graphData[1];
        var deviceOk=this.graphData[2];
        var deviceFail=this.graphData[3];
        var deviceDisc=this.graphData[4];
        var deviceOrphan=this.graphData[5];
        // var deviceUvoxyFail=this.graphData[5];
        // var deviceOrphan=this.graphData[6];
        // console.log("Donut: Ok", deviceOk, " Fail", deviceFail, " Disc", deviceDisc, " UvoxyFail", deviceUvoxyFail, " Orphan", deviceOrphan, " Total", this.totalDevice);
        this.sections=[];
        var deviceOk_p, deviceFail_p, deviceDisc_p, deviceOrphan_p; //deviceUvoxyFail_p,
        if (this.totalDevice==0){
          deviceOk_p={value:0, color:"#29CC96"};
          deviceFail_p={value:0, color:"#F03040"};
          deviceDisc_p={value:0, color:"#b5b3b3"};
          //deviceUvoxyFail_p={value:0, color:"#3287a8"};
          deviceOrphan_p={value:0, color:"#EE82EE"};
        } else {
          // deviceOk_p={label: this.$t("graph.report_lamp_pass"), value:(deviceOk/this.totalDevice)*100, color:"#29CC96"};
          // deviceFail_p={label: this.$t("graph.lamp_fail"), value:(deviceFail/this.totalDevice)*100, color:"#F03040"};
          // deviceDisc_p={label: this.$t("graph.not_exec"), value:(deviceDisc/this.totalDevice)*100, color:"#b5b3b3"};
          // deviceUvoxyFail_p={label: this.$t("graph.uv_fail"), value:(deviceUvoxyFail/this.totalDevice)*100, color:"#3287a8"};
          // deviceOrphan_p={label: this.$t("graph.orphan"), value:(deviceOrphan/this.totalDevice)*100, color:"#EE82EE"};
            deviceOk_p={value:(deviceOk/this.totalDevice)*100, color:"#29CC96"};
            deviceFail_p={value:(deviceFail/this.totalDevice)*100, color:"#F03040"};
            deviceDisc_p={value:(deviceDisc/this.totalDevice)*100, color:"#b5b3b3"};
            //deviceUvoxyFail_p={value:(deviceUvoxyFail/this.totalDevice)*100, color:"#3287a8"};
            deviceOrphan_p={value:(deviceOrphan/this.totalDevice)*100, color:"#EE82EE"};
        }

        console.log("Donut, deviceOK: ", deviceOk_p, " deviceFAIL: ", deviceFail_p, " deviceDisc: ", deviceDisc_p, " deviceOrphan: ", deviceOrphan_p);
        this.sections.push(deviceOk_p);
        this.sections.push(deviceFail_p);
        this.sections.push(deviceDisc_p);
        //this.sections.push(deviceUvoxyFail_p);
        this.sections.push(deviceOrphan_p);
    },
    data() {
      return {
          sections: [],
          totalDevice: 0,
          hoveredSection: null
      };
    },
    methods: {
      handleMouseOver(section) {
        // this.hoveredSection = section;
      },
      handleMouseOut() {
        // this.hoveredSection = null;
      }
    }
  };
</script>
